import React from 'react';
import {IconButton, Tooltip} from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

/** sx fragment that turns a Paper/Box into a full-viewport overlay. Spread into an
 *  element's sx where its fullscreen flag is on, e.g.
 *  `sx={{ ...base, ...(isFullscreen && FULLSCREEN_OVERLAY_SX) }}`.
 *  Panels that also need to scroll add `overflow: 'auto'` after the spread. */
export const FULLSCREEN_OVERLAY_SX = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1300,
    m: 0,
    borderRadius: 0,
    backgroundColor: 'background.paper',
} as const;

interface FullscreenToggleProps {
    /** True when the panel is currently fullscreen (renders the exit icon). */
    active: boolean;
    onToggle: () => void;
    /** Tooltip shown when not fullscreen (default 'Fullscreen'). */
    enterTooltip?: string;
}

/** Enter/exit-fullscreen icon button shared across the IRP workbook analysis panels. */
export const FullscreenToggle: React.FC<FullscreenToggleProps> = ({active, onToggle, enterTooltip = 'Fullscreen'}) => (
    <Tooltip title={active ? 'Exit fullscreen' : enterTooltip}>
        <IconButton size="small" onClick={onToggle}>
            {active ? <FullscreenExitIcon fontSize="small" /> : <FullscreenIcon fontSize="small" />}
        </IconButton>
    </Tooltip>
);
